import { render } from "./GeneralAgreementManager.vue?vue&type=template&id=e3432a8c"
import script from "./GeneralAgreementManager.vue?vue&type=script&lang=js"
export * from "./GeneralAgreementManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__